import { Observable } from "rxjs";
import { Usuario } from "../../../../shared/models/usuario.model";

export abstract class SeguridadGateway {

    abstract login(urlInicio: string): Observable<any>;

    abstract checkLogin(): Observable<boolean>;

    abstract datosUsuarioLogueado(): Observable<Usuario>;

    abstract cerrarSesion(): Observable<string>;

}
